import { default as cameraDock } from "../Cameras/reducer";
import { default as dockData } from "../reducer";
import { default as onlineUsers } from "../OnlineUsers/Redux/reducer";

import { combineReducers } from "redux";

const dock = combineReducers({
	cameraDock,
	dockData,
	onlineUsers
});

export { default as notifications } from "../NotificationsCenter/notifications/reducer";
export { default as reminders } from "../NotificationsCenter/reminders/reducer";
export { default as alerts } from "../Alerts/reducer";
export default dock;
